import {Component, OnInit, ViewChild} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {FlashMessagesService} from 'angular2-flash-messages';
import {Utils} from '../shared/utils';

import {Trabalho} from './trabalho';
import {Autor} from '../autor/autor';
import {CategoriaCientifica} from '../categoria_cientifica/categoria_cientifica';

import {CategoriaCientificaService} from '../categoria_cientifica/categoria_cientifica.service';
import {TrabalhoService} from '../trabalho/trabalho.service';
import {AcessoService} from "../acesso/acesso.service";
import {AppComponent} from "../app.component";

import {InscricaoService} from "../inscricao/inscricao.service";
import {CadastroService} from "../cadastro/cadastro.service";

declare var jQuery:any;

@Component({
    selector: 'app-trabalho',
    templateUrl: './trabalho.component.html',
    styleUrls: ['./trabalho.component.css'],
    providers: [
        CategoriaCientificaService,
        TrabalhoService,
        AcessoService,
        InscricaoService,
        CadastroService
    ]
})
export class TrabalhoComponent extends AppComponent implements OnInit {

    trabalho: Trabalho;
    maximo_autores: number;
    categorias: CategoriaCientifica[];
    subcategorias: CategoriaCientifica[];
    categoria_cientifica: number;
    mensagemErro: string;
    palavras_resumo: number;
    palavras_resumo_restantes: number;
    max_palavras_resumo: number;
    aplicacao: AppComponent;
	email: string;
	unidades_executoras: string[];
    @ViewChild('parecer') input_parecer: any;

    ngOnInit() {
        if (!this.islogged()) 
            this.router.navigateByUrl('acesso');
		else {
			this.email = this.acessoService.getUsuario().email;
			
			this.trabalho = new Trabalho;
			this.max_palavras_resumo = 250;
			this.palavras_resumo_restantes = this.max_palavras_resumo;
			this.trabalho.autores = [];
			this.trabalho.datas_ini = [null];
			this.trabalho.datas_fim = [null];
			this.maximo_autores = 9;
			this.categoriaCientificaService.get()
				.then(categorias => this.categorias = categorias);
		   
			this.unidades_executoras = this.trabalhoService.unidades_executoras;	
			this.route.params.subscribe(params => this.trabalho.inscricao_id = params['id']);

			if (this.trabalho.resumo === undefined) {
				this.trabalho.resumo = '';
			}
			this.contaPalavrasResumo();
		}
    }

    checkautor(email,index){
		
        let dados= new Object();
        dados['email']=email;
        dados['index']=index;
        this.inscricaoService.getInscricao(this.trabalho.inscricao_id)
            .then( inscricao => {return this.getUsuario(dados,inscricao);});
    }

    getUsuario(dados, inscricao){
        dados['evento_id']=inscricao.evento_id;
        this.cadastroService.getUserbyMail(dados)
            .then( usuario => {
				if (!usuario.id) {
					this.utils.exibirMensagem('O co-organizador precisa estar inscrito no edital.', 'warning');
					this.clearautor(dados['index']);
					return false;
				} else 
					return this.setautor(dados,usuario);
			})

    }


    setautor(dados,usuario){

        if(usuario.nome!=undefined){
            this.setuserautor(dados['index'],usuario);
        }

        return this.checkemail(dados['email'],dados['index']);
    }

    checkemail(email,index){
        let autores=this.trabalho.autores;
        let that=this;
		
		if (email.toUpperCase() == this.email.toUpperCase()) {
			this.utils.exibirMensagem('O responsável não pode ser indicado novamente como co-organizador.', 'warning');
			this.clearautor(index);
			return false;
		}
		
        autores.forEach(function (autor,i) {	
            if (autor.email.toUpperCase() == email.toUpperCase() && i != index){
				that.utils.exibirMensagem('Você já indicou esse co-organizador.', 'warning');
                that.clearautor(index);
				return false;
            }
        })
        return  true;
    }

    clearautor(index){
        jQuery('#email'+index).val("");
        jQuery('#nome'+index).val("");
        this.trabalho.autores[index].email='';
        this.trabalho.autores[index].nome='';
        this.trabalho.autores[index].referencia='';
        jQuery('#nome'+index).prop("disabled",false);
        jQuery('#email'+index).prop("disabled",false);
		jQuery(':submit').prop("disabled",true);
		jQuery('#adicionar').prop("disabled",true);
    }

    setuserautor(index,user){
		jQuery('#nome'+index).prop("disabled",true);
        jQuery('#email'+index).prop("disabled",true);
        this.trabalho.autores[index].nome=user.nome;
        this.trabalho.autores[index].referencia=user.reference;
		jQuery(':submit').prop("disabled",false);
		jQuery('#adicionar').prop("disabled",false);
    }

    aviso(quant,email,index){
        if (quant >= 9) {
            this.utils.exibirMensagem('E-mail: '+ email + ' não pode ser indicado, já atingiu limite de propostas.', 'warning');
            this.clearautor(index);
        }

    }


    listarSubcategorias() {
        //seta o id do pai ao trabalho, será sobrescrito se houver um filho

        let subcategorias: CategoriaCientifica[];
        this.subcategorias = subcategorias;

        this.trabalho.categoria_cientifica_id = this.categoria_cientifica;
        // console.log(this.trabalho.categoria_cientifica_id);

        this.categoriaCientificaService.getParents(this.categoria_cientifica)
            .then(subcategorias => {
                this.subcategorias = (subcategorias.length > 0) ? subcategorias : null;
            });
    }

    adicionarAutor() {
        if (this.permiteAdicionarAutores()) {
			jQuery(':submit').prop("disabled",true);
			jQuery('#adicionar').prop("disabled",true);
            this.trabalho.autores.push(new Autor());
        } else {
            //console.log('Número máximo de autores atingido!');
        }
    }

    removerAutor(index) {
		let autor = this.trabalho.autores[index];
		if (!autor.nome || !autor.nome.length) {
			jQuery(':submit').prop("disabled",false);
			jQuery('#adicionar').prop("disabled",false);
		}
        if (index > -1) {
            this.trabalho.autores.splice(index, 1);
        }
    }

    permiteAdicionarAutores(): boolean {
        return (this.trabalho.autores.length < this.maximo_autores);
    }

    upload(event: any):void{
      let parecer: FileList = event.target.files;
      let arquivo: File = parecer[0];
      this.trabalho.parecer = arquivo;
    }

    categoriasComParecer(): boolean {
      return (this.trabalho.categoria_cientifica_id == 1 || this.trabalho.categoria_cientifica_id == 2)
    }

    resetParecer() {
      if(this.input_parecer && !this.categoriasComParecer()) {
        this.trabalho.parecer = null;
        this.input_parecer.value = '';
      }
    }

    onSubmit() {
		if (this.trabalho.enviado == null)
			this.trabalho.enviado = false;
		if (this.trabalho.enviado && !this.trabalho.parecer) {
			this.trabalho.enviado = false;
			this.utils.exibirMensagem('Ao enviar em definitivo é preciso anexar o PDF.', 'warning');
        } else {
			let erro: string = this.trabalhoService.validarDatas(this.trabalho);
			if (erro)
				this.utils.exibirMensagem(erro, 'warning');
			else {
				this.trabalho.modalidade_id = 1;
				this.spinnerService.show();
				this.trabalhoService.salvar(this.trabalho, false)
					.then(response => {
						if (!this.trabalho.enviado)
							this.utils.exibirMensagem('Proposta salva com sucesso! ATENÇÃO, ALUNO RESPONSÁVEL! O evento proposto foi APENAS SALVO; para finalizar é necessário apertar o botão ENVIAR!', 'success');
						else
							this.utils.exibirMensagem('Proposta enviada em DEFINITIVO com sucesso!', 'success');
						  this.router.navigateByUrl('eventos');
						  this.spinnerService.hide();
						});
			}
		}
	}

    limparResumo(): void {
        this.trabalho.resumo = '';
        this.palavras_resumo_restantes = this.max_palavras_resumo;
    }

    contaPalavrasResumo(): void {
        this.palavras_resumo = this.trabalho.resumo.split(' ').length;
        this.restantePalavrasResumo()
    }

    restantePalavrasResumo(): void {
        if ((this.palavras_resumo_restantes > 0) && (this.palavras_resumo <= this.max_palavras_resumo)) {
            this.palavras_resumo_restantes = this.max_palavras_resumo - this.palavras_resumo;
        } else {
            this.palavras_resumo_restantes = 0;
        }
    }

    trim(str) {
        str=str.toLowerCase();
        return str.replace(/^\s+|\s+$/g,"");
    }

    goBack(){
		if (this.isAdmin())
			this.router.navigate(['/avaliacao']);
        else
			this.router.navigate(['/trabalho-list']);
    }
	
	maskphone(field_id: string): void {
        this.trabalho[field_id]=this.utils.maskphone(field_id);
    }
}



// WEBPACK FOOTER //
// ./src/app/trabalho/trabalho.component.ts